import styled from 'styled-components'

export const TagWrapper = styled.div`
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  padding: 0.125rem 0.1875rem;
`
